import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-3 loyalty-bonus-levels text-center",
      attrs: { "data-qa": "bonus_levels" },
    },
    [
      _vm.bonusLevels.length === 1
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center mx-auto",
              attrs: { "data-qa": "bonus_levels_solo" },
            },
            [
              _c(VIcon, { attrs: { color: "special", size: "28" } }, [
                _vm._v("\n      ui-icon-four-pointed-star-fill\n    "),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-stat-item text--text" }, [
                _c(
                  "span",
                  { attrs: { "data-qa": "bonus_levels_item_bonus" } },
                  [_vm._v(_vm._s(_vm.bonusLevels[0].percent_amount))]
                ),
                _vm._v("%\n    "),
              ]),
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "d-flex justify-center gc-1 py-2 px-4 w-100" },
              [
                _vm._l(
                  _vm.bonusLevels,
                  function ({ percent_amount, need_spend }, index) {
                    return [
                      index !== 0
                        ? _c(
                            "div",
                            {
                              key: `${percent_amount}-${need_spend}-line`,
                              staticClass:
                                "loyalty-bonus-levels__item loyalty-bonus-levels__item--line",
                            },
                            [
                              _c("span", { staticClass: "text-h6" }, [
                                _vm._v(" "),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "loyalty-bonus-levels__line font-size-12 rounded-pill special",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: `${percent_amount}-${need_spend}`,
                          staticClass:
                            "loyalty-bonus-levels__item loyalty-bonus-levels__item--bonus",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-h6 text--text text-no-wrap" },
                            [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-qa": "bonus_levels_item_percent",
                                  },
                                },
                                [_vm._v(_vm._s(percent_amount))]
                              ),
                              _vm._v("%\n          "),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "font-size-12 ui-icon-four-pointed-star-fill special--text",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-caption-2 text-secondary--text text-no-wrap",
                              attrs: {
                                "data-qa":
                                  "bonus_levels_item_spending_need_spend",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _setup.formatPrice({ price: need_spend })
                                  ) +
                                  " " +
                                  _vm._s(_setup.context.currency.symbol) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "text-body-2 text-secondary--text",
                class: { "text-pre-line": _setup.isMobile },
              },
              [
                _vm._v(
                  _vm._s(
                    _setup.t(
                      "Размер бонуса зависит от\nобщей суммы трат в клинике",
                      _setup.options
                    )
                  )
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }